import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

import {
  SR_API_ACTION_APARTMENT_TOURS_SUBMIT_TOUR_FEEDBACK,
  SR_API_ACTION_TOUR_GET_BY_ID,
} from 'api/actionTypes';

import { SCREEN_ID_LOCATOR_TOURS_FEEDBACK_PAGE } from 'client/constants/screenIds';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import postWithState from 'client/actions/postWithState';
import branch from 'client/core/branch';

import SrText from 'client/components/SrText';
import SrBox from 'client/components/SrBox';
import SrContactUsButton from 'client/components/SrContactUsButton';
import SrLocatorToursNavbar from 'client/components/SrLocatorToursNavbar';
import SrLocatorToursFeedback from 'client/components/SrLocatorToursFeedback';

@withTransitionHook
@withScreenId(SCREEN_ID_LOCATOR_TOURS_FEEDBACK_PAGE)
@withScrollToTop
@branch()
class LocatorToursFeedbackPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Locator Tours',
  });

  static propTypes = {
    history: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      tour: null,
    };
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(postWithState, {
      action: SR_API_ACTION_TOUR_GET_BY_ID,
      payload: {
        tourId: parseInt(match.params.tourId, 10),
      },
    }).then((tour) => {
      this.setState({
        tour,
      });
    });
  }

  _onRenterFeedbackSubmit = (values) => {
    const { history, dispatch, match } = this.props;
    dispatch(postWithState, {
      action: SR_API_ACTION_APARTMENT_TOURS_SUBMIT_TOUR_FEEDBACK,
      payload: {
        tourId: values.tourId,
        renterFeedback: values.renterFeedback,
      },
      onSuccess() {
        const apartmentId = parseInt(match.params.apartmentId, 10);
        history.push(`/locatortours/${apartmentId}/success`);
      },
    });
  };

  render() {
    const { tour } = this.state;
    if (!tour) {
      return null;
    }

    const tourFeedbackSubmitted = tour.listings.some(({ showingUserRating }) => {
      return typeof showingUserRating === 'number' && showingUserRating > 0;
    });

    if (tourFeedbackSubmitted) {
      return <Redirect to="/locatortours" />;
    }

    const floorPlans = tour.listings.map((listing) => ({
      ...listing,
      showUnits: [listing],
      otherUnits: [],
    }));

    return (
      <div>
        <SrLocatorToursNavbar
          withLogo
          redirectTo="/locatortours"
          withTopPadding
          cornerNode={<SrContactUsButton />}
        />
        <SrBox paddingBottom="130px">
          <SrBox paddingBottom="20px" marginRight={20} marginLeft={20}>
            <SrText font="greycliff" size="40" weight="bolder" leading="45">
              Write Renter Feedback
            </SrText>
          </SrBox>
          <SrBox margin="0 10px 150px">
            <SrLocatorToursFeedback
              tourId={tour.id}
              floorPlans={floorPlans}
              onSubmit={this._onRenterFeedbackSubmit}
            />
          </SrBox>
        </SrBox>
      </div>
    );
  }
}

LocatorToursFeedbackPage.displayName = 'LocatorToursFeedbackPage';

export default LocatorToursFeedbackPage;
